import { Component, OnInit, SimpleChanges, OnDestroy } from '@angular/core';
import { DatePipe, CommonModule } from '@angular/common';
import {default as GridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-Error-Codes-Columns.json';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { HttpErrorResponse } from '@angular/common/http';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { Subscription } from 'rxjs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { GridComponent } from 'app/Shared/Modules/non-transactional-grid/grid/grid.component';
import { QuickSearchComponent } from "app/Shared/Component/quick-search/quick-search.component";
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UserService } from 'app/Shared/Services/user.service';
import { generateCsv, asBlob } from 'export-to-csv';
import saveAs from 'file-saver';
import { MessageService } from 'primeng/api';
import { UrlsService } from 'app/Shared/Services/urls.service';

@Component({
    selector: 'app-error-codes',
    imports: [FilterPanelComponent, GridComponent, QuickSearchComponent, CommonModule, MatProgressSpinner],
    templateUrl: 'cat-error-codes.component.html',
    styleUrls: ['cat-error-codes.component.scss']
})
export class CATErrorCodesComponent implements OnInit, OnDestroy {

    quickFilterArray: any = GridColumnsJSON["cat-error-codes-quick-search-fields"];
    GridColumns = GridColumnsJSON["cat-error-codes-grid-columns"];
    panelOpenState: boolean;
    dataset1: any[] = [];
    DefaultFilterArray: any = [];
    isLoadingResults = true;
    Limit: any = { 'Start': '', 'End': '' };
    totalRecords: any;
    rowcount!: number;
    startLimit: any = 0;
    endLimit!: number;
    subscription!: Subscription;
    constructor(
      private gridService: GridService,
      private emitterService: EmitterService,
      private datePipe: DatePipe,
      public constantService: ConstantService,
      private sharedHttpClientService: SharedHttpClientService,
      private userService: UserService,
      private urlsService: UrlsService,
      private messageService: MessageService) {
          this.panelOpenState = false;
    }

    ngOnInit(): void {
      this.rowcount = this.gridService.getGridRowsCount();
      this.Limit = { 'Start': '0', 'End': this.rowcount };
      this.totalRecords = this.rowcount;
      this.dataset1 = [];
      this.defaultFilter();
      this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
        if (value) {
          this.getData();
        }
      });
    }

    updateDefaultArray($event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = $event;
      this.Limit.Start = 0;
      this.getData();
    }
  
    clearQuickSearch($event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = $event;
      this.Limit.Start = 0;
      this.getData();
    }

    FilterApplyFilterEvent(event: any) {
      this.emitterService.isResetGridLimit.emit(true);
      this.DefaultFilterArray = [];
      this.DefaultFilterArray = event;
      this.startLimit = 0;
      this.Limit.Start = 0;
      this.getData();
    }

    GridChangeLimitEvent(event: any) {
      this.Limit = event;
      this.getData();
    }

    defaultFilter() {
        this.DefaultFilterArray = [
          { 'isdefault':  'true', 'label': 'Error Code', 'columnname': 'Error_Code', 'filterby': 'IS', 'values': '', 
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' },
          { 'isdefault':  'true', 'label': 'Error Code Description', 'columnname': 'Error_Code_Description', 'filterby': 'IS', 'values': '', 
          'datatype': 'String', 'disabled': 'true', 'dropdown': '', 'dropdownvalue': '' }
        ];
        this.getData();
    }

    getData() {
      this.isLoadingResults = true;
      this.gridService.prepareData(APIURL.CAT_Error_Codes, this.DefaultFilterArray, this.Limit, 'CAT-Error-Codes')
        .subscribe({
          next: (Element:any) => {
          this.isLoadingResults = false;
          let dataset: any;
          dataset = Element;
          this.dataset1 = dataset.Data;
          this.totalRecords = dataset.totalCount;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
        }, error: (err: HttpErrorResponse) => {
          this.dataset1 = [];
          this.totalRecords = 0;
          this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
          this.isLoadingResults = false;
        }});
    }

        exportToCSV(response: any) {
          let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
          let exportLimt: any;
          if (response.event.isExportMaxRows) {
            exportLimt = { 'Start': this.constantService.NUMBER_0, 'End': this.constantService.NUMBER_MAX_EXPORT_ROWS };
          } else {
            exportLimt = this.Limit;
          }
    
          const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    
          let payload = {
            data: JSON.parse(JSON.stringify(filterData)),
            startLimit: exportLimt.Start.toString(),
            endLimit: exportLimt.End.toString()
          }
    
          this.sharedHttpClientService.post(
            this.urlsService.setAPIURl(
              APIURL.CAT_Error_Codes
            ),
            payload
          ).subscribe({
            next: (Element:any) => {
            let APIResponse = Element;
            let exportData = APIResponse.Data;
            if(exportData.length > 0) {
              const options : any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: 'RSMS_CAT_Error_Codes_Details_' + this.userService.getyyyyMMddDateFormate(new Date()),
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: this.userService.getActiveMPID() + 'RSMS_CAT_Error_Codes_Details_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
              };
              const csvData = this.constantService.getExportData(exportData, response.event.gridColumn);
              const csv = generateCsv(options)(csvData);
              const blob = asBlob(options)(csv);
              saveAs(blob,options.filename);
              this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
              this.userService.logUserActivity('Export CSV', null, {
                'Text1': 'File Download Successfully | ' + (exportData.length > 0 ? exportData.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV', null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
            this.emitterService.exportToCSVData.emit(true);
          },
          error: (err: HttpErrorResponse) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
            this.userService.logUserActivity('Export CSV', null, {
              'Text1': 'Error while Exporting',
              'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
            });
          }});
          
        }
        
    ngOnDestroy() {
      if(this.subscription)
    this.subscription.unsubscribe();
    }
}
